var _defs, _path, _path2, _ellipse, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle, _path27, _path28, _path29, _path30, _path31, _polygon, _polygon2, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _line, _line2, _line3, _line4, _path40, _path41, _line5, _line6, _line7, _line8, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1027.35,
    height: 798.89,
    viewBox: "0 0 1027.35 798.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "60552b3d-cc23-4bcb-bcbd-c0b00e2743d7-66",
    x1: 454.54,
    y1: 832.71,
    x2: 454.54,
    y2: 147.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "workout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1093.8,263.12a250.48,250.48,0,0,0-40.75-64.93l-565.37-5.57,465.49-65.38a264.39,264.39,0,0,0-94.45-18.74A264.72,264.72,0,0,0,542.51,97.8a263.57,263.57,0,0,0-121-29.16c-125.62,0-230.3,87-253.78,202.38Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.68,359.88a244.38,244.38,0,0,0-17.62-91.32L116.2,371.41a245.29,245.29,0,0,0-23,58l303.43,45.24-310.36,33c9.34,130.61,121.31,233.75,258.09,233.75,68.85,0,131.42-26.14,177.77-68.76,46.51,43.43,109.67,70.13,179.26,70.13,103.26,0,192.38-58.79,233.88-143.8,83.27-26.42,147.95-92.78,170.09-175.79L721.68,363.62h392C1113.66,362.37,1113.68,361.13,1113.68,359.88Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.68,
    cy: 761.68,
    rx: 227,
    ry: 37.21,
    fill: "#eb5200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M607.77,572.54c-10.21,2.56-20.69-2.42-20.69-2.42s-8.94-10.35-16.48-11.75-10.46,10.85-14.94,14c-3.1,2.21-25.46.63-39-.55l-2.33-.21c-.23-.17-.46-.35-.71-.51,0,0-13-4-15.71-7.54s-20.82-10.09-26.44-9.71-22.23,1.28-22.23,1.28-6.51-7.41-9.45-6.64-13.16-.06-13.16-.06-2.81-7.22-5.62-17.57c-1.31-4.83-5.67-8.22-9.94-10.45,3.84-13-3-50.08-24.24-57.33-4.63-1.58-7-6.83-10.94-9.71-3.53-2.57-9.31-8.63-6.48-19.58,4-15.33,13.92-39.47,13.92-39.47l7.39-14.76a20.62,20.62,0,0,1-2.34,2.93c1-1.28,2-2.54,2.86-3.6a62.13,62.13,0,0,0,23.66,6.52c8.34,3.37,16.67,6.34,19.91,6.23,7.41-.26,26.31,9.2,26.31,9.2s45.47,13,54.92,14.05,14.05-11.24,14.05-11.24S535,379.42,526.28,373s-13.79,23-13.79,23L453,374.56l-3.67-1.93A33.35,33.35,0,0,0,456,362.25c.92-2.29,1.76-4.91,3.95-6.05a5.58,5.58,0,0,1,1.88-.55,12.67,12.67,0,0,1,1.63,0c10.32.63,19.19,8.75,29.53,8.79.38,0,.76,0,1.14,0a9.94,9.94,0,0,0,5.53-1.7,8.68,8.68,0,0,0,3.18-6.14,10.54,10.54,0,0,1-.5.94,12.33,12.33,0,0,0,0-4.45c-.64-3.51-2.47-6.66-4.11-9.83a5,5,0,0,1-.76-2.46,3.39,3.39,0,0,1,1.29-2.33,2.8,2.8,0,0,0,.06.28,13.07,13.07,0,0,1,2.58-1.89,22.06,22.06,0,0,0,9.64-14.69c-.25.74-.55,1.47-.87,2.19A21.71,21.71,0,0,0,509.12,309a8.69,8.69,0,0,0-2.66-3.49c-3.73-2.62-8.74.17-13.29.47-4,.26-7.88-1.53-11.49-3.34-6.16-3.09-12.29-6.43-17.42-11-5.83-5.23-10.16-11.9-15.42-17.69S436.83,263,429,262.42c-14.23-1.1-27.65,13-41.18,8.4-6.6-2.23-10.94-8.33-15.53-13.57s-10.9-10.27-17.78-9.14c-4.78.8-8.92,4.51-13.76,4.37-2.53-.08-4.88-1.21-7.28-2-5.81-1.95-13.77-1-15.84,4.78a8.52,8.52,0,0,0,.75,7.17,10.78,10.78,0,0,0-.82,1.35,4.62,4.62,0,0,0-.49,3,30.9,30.9,0,0,0,12.2,52.72c.19.73.38,1.46.56,2.2,1.94,8.17,2.95,17.37.08,23.57-.18.38-.37.75-.58,1.11l-.25.11.11.11h0l-.11-.11h0l-.36-.37h0l-2.18-2.28c-.12-2.38-1.46-8.76-10.78-20.6-12.27-15.59-14.57-41.39-14.57-41.39s-3.06-13.28,0-17.11,8.18-46,8.18-46L317.83,195s41.13-41.9,24-47c-11.63-3.47-25.5,14.41-33.2,26.23a46.77,46.77,0,0,0-7.16,19.24l-23.25,63.61s-2.3,7.67,0,20.95,7.41,36.79,7.41,36.79l13,32.95S303.42,362,303,368.18c-.57.37-2.57,4.33-4.3,7.93l-1.27,2-.09.81c-.85,1.81-1.44,3.11-1.44,3.11s-7.24,21.37-1.19,34.48S301,435.7,301,435.7l4.51,19.42,1.88,17,16.22,40.11,14.94,21.33s-1.4,15.71-4.47,17.88-1.66,13.41-1.66,13.41l-1.92,29.5s-6,8.82-6.38,23.12-2.56,18.4-2.56,18.4-1,12,1.79,17.5-4.47,11.24-4.47,11.24L325.11,686l-2.43,27.08s1.13.31,3,.78l-.38,1.94-10.16,51.3s-5.49,14.06-5.74,17.37l-17.76,32.07s-14.82,14.69-7.79,16.09,27.47-11.24,27.47-11.24,16.86-18.14,23.5-19.79,14-6.4,11.88-13.29-7-17.37-2.3-28.49c3-7,9.38-26,13.76-39.26.24-.73.47-1.43.7-2.11a17.77,17.77,0,0,0,3.42-.65c10.73-3.32,16.35-1,16.35-1l19.16-77.53L402,600.37l26.83,22.38a32.25,32.25,0,0,0,18.8,7.43c10.57.62,27.06,2.15,39,5.84l5-20.82s14.3.52,17.37-4.34c1.25-2,2.48-3.7,3.49-5l2.32-.36,63.29-9.79c11.75,0,27.85-7.93,27.85-7.93l9.84-1.91s14.68-2.94,16-5.37S618,570,607.77,572.54Z",
    transform: "translate(-86.32 -50.56)",
    fill: "url(#60552b3d-cc23-4bcb-bcbd-c0b00e2743d7-66)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.58,260.27c2-5.64,9.82-6.59,15.51-4.68,2.34.78,4.65,1.89,7.12,2,4.74.14,8.79-3.5,13.47-4.27,6.73-1.12,12.9,3.8,17.39,8.93s8.75,11.1,15.21,13.29c13.23,4.46,26.37-9.3,40.29-8.23,7.64.59,14.24,5.62,19.39,11.29s9.39,12.19,15.09,17.31c5,4.5,11,7.77,17.05,10.8,3.53,1.77,7.3,3.52,11.24,3.26,4.46-.29,9.36-3,13-.46a8.49,8.49,0,0,1,2.6,3.42c4.48,9.32.87,21.73-7.9,27.21-1.53.95-3.39,2-3.48,3.83a4.82,4.82,0,0,0,.74,2.41c1.6,3.1,3.4,6.19,4,9.62s-.21,7.38-3,9.46a10.18,10.18,0,0,1-6.17,1.69c-10.12-.05-18.8-8-28.9-8.61a7.3,7.3,0,0,0-3.79.58c-2.14,1.11-3,3.68-3.87,5.92-4.68,11.69-16.3,19.82-28.7,22.05s-25.35-.91-36.45-6.87a8.61,8.61,0,0,1-2.21-1.52,9.45,9.45,0,0,1-1.91-3.87c-3.4-10.75-8-22-17.42-28.21-6.11-4-14.4-6.25-17.17-13-1.74-4.27-.65-9.12-1.09-13.72a21.09,21.09,0,0,0-13.93-17.58c-1.64-.55-3.44-.94-4.64-2.19a8.64,8.64,0,0,1-1.8-4.25c-1.49-6.77-2.48-13.92-4.56-20.53C324.1,270.17,318.45,266.2,320.58,260.27Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#663d5b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.47,362.35A10.22,10.22,0,0,1,493.3,364c-10.11,0-18.79-8-28.89-8.6a7.29,7.29,0,0,0-3.79.57c-2.15,1.11-3,3.68-3.87,5.92-4.68,11.7-16.31,19.83-28.71,22.06s-25.35-.91-36.44-6.87a8.69,8.69,0,0,1-2.21-1.52,9.51,9.51,0,0,1-1.91-3.87c-3.4-10.76-8-22-17.42-28.22-6.12-4.05-14.41-6.24-17.17-13-1.75-4.28-.66-9.13-1.09-13.72a21.07,21.07,0,0,0-13.94-17.58c-1.64-.55-3.44-.95-4.64-2.19a8.57,8.57,0,0,1-1.79-4.26c-1.5-6.76-2.48-13.92-4.56-20.52-1.4-4.42-5.81-8-5.59-12.72a6.65,6.65,0,0,0-.34.77c-2.14,5.93,3.52,9.9,5.13,15,2.08,6.6,3.06,13.76,4.56,20.52a8.57,8.57,0,0,0,1.79,4.26c1.2,1.24,3,1.64,4.64,2.19A21.07,21.07,0,0,1,351,319.81c.43,4.59-.66,9.44,1.09,13.72,2.76,6.79,11.05,9,17.17,13,9.4,6.23,14,17.46,17.42,28.22a9.51,9.51,0,0,0,1.91,3.87,8.69,8.69,0,0,0,2.21,1.52c11.09,6,24,9.09,36.44,6.87s24-10.36,28.71-22.06c.9-2.24,1.73-4.81,3.87-5.92a7.29,7.29,0,0,1,3.79-.57c10.1.61,18.78,8.56,28.89,8.6a10.22,10.22,0,0,0,6.17-1.68,8.48,8.48,0,0,0,3.12-6A7.43,7.43,0,0,1,499.47,362.35Z",
    transform: "translate(-86.32 -50.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.21,337c-1.53,1-3.4,2-3.49,3.83a3.05,3.05,0,0,0,.17,1.08,12.59,12.59,0,0,1,2.52-1.85,21.55,21.55,0,0,0,9.43-14.37A21.07,21.07,0,0,1,501.21,337Z",
    transform: "translate(-86.32 -50.56)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M346.75,754c-4.63,10.88.13,21.12,2.25,27.88s-5.12,11.37-11.62,13-23,19.37-23,19.37-20,12.37-26.88,11,7.62-15.75,7.62-15.75l17.38-31.38c.25-3.24,5.62-17,5.62-17l9.94-50.2,1.32-6.67,35.24-2.13s-1.85,5.72-4.4,13.45C355.93,728.57,349.65,747.21,346.75,754Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#cc818c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M628,578.53c-1.25,2.38-15.62,5.25-15.62,5.25l-9.63,1.87s-15.75,7.76-27.25,7.76L513.56,603l-8.31,1.29V569.15s4.18.44,10.1,1c13.23,1.16,35.12,2.7,38.15.54,4.38-3.12,7.25-15.12,14.62-13.74s16.13,11.5,16.13,11.5,10.25,4.87,20.25,2.37S629.25,576.15,628,578.53Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#cc818c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M515.75,600.28s-.89,1-2.19,2.71l-8.31,1.29V569.15s4.18.44,10.1,1C525.29,578,515.75,600.28,515.75,600.28Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M396.13,592.16l33.27,27.76a31.58,31.58,0,0,0,18.4,7.27c10.34.61,26.48,2.1,38.2,5.72l4.88-20.38s14,.5,17-4.25a68.93,68.93,0,0,1,5.87-8s10.13-23.62-1.37-30.87c0,0-12.75-3.88-15.38-7.38s-20.37-9.87-25.87-9.5-21.75,1.25-21.75,1.25-6.38-7.25-9.25-6.5-12.88,0-12.88,0-2.75-7.07-5.5-17.2-19.12-13.75-19.12-13.75Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#565987"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.13,592.16l33.27,27.76a31.58,31.58,0,0,0,18.4,7.27c10.34.61,26.48,2.1,38.2,5.72l4.88-20.38s14,.5,17-4.25a68.93,68.93,0,0,1,5.87-8s10.13-23.62-1.37-30.87c0,0-12.75-3.88-15.38-7.38s-20.37-9.87-25.87-9.5-21.75,1.25-21.75,1.25-6.38-7.25-9.25-6.5-12.88,0-12.88,0-2.75-7.07-5.5-17.2-19.12-13.75-19.12-13.75Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M381.25,343.28l-3.68.69-.23,0-.54.1-6.3,1.17-1.94,2.3-.08.08L362.25,355,357,360.15l-.05.06-4.44,4.32L345,372l-1.26,3.11L341,382l-.71,1.75-7.5,8L328,402l-11.2,6.5-12.05-6.25-5.5-8,1.25-11.46.25-2.29,3.67-5.89,3.33-5.36,6.5-9.25,12.5-8.5,2.24-.59,2.51-.66a9.29,9.29,0,0,0,.53-.85,10.23,10.23,0,0,0,.57-1.09c2.81-6.06,1.82-15.07-.08-23.06a116,116,0,0,0-5.77-17.5l33-4.75s-.32,6.4-.32,16.38h0c0,2.5,0,5.21.07,8.11.16,9,8.52,12.9,14.83,14.56a41.56,41.56,0,0,0,4.94,1C380.49,343.24,381.25,343.28,381.25,343.28Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#cc818c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M329.25,348s1.5-6-10.5-21.25-14.25-40.5-14.25-40.5-3-13,0-16.75,8-45,8-45l8.25-23.25s40.25-41,23.5-46c-11.38-3.4-25,14.11-32.49,25.67a45.75,45.75,0,0,0-7,18.83h0L282,262s-2.25,7.5,0,20.5,7.25,36,7.25,36L302,350.78s6.71,20.1,3.23,22.55L313,361.84Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#cc818c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M528.5,405.53s-4.5,12-13.75,11S461,402.78,461,402.78s-18.5-9.25-25.75-9-40.5-15.25-40.5-15.25-2.34,3.08-4.95,6.32c-2.84,3.55-6,7.3-6.8,7.43-1.5.25-24.75,3.5-24.75,3.5l-15.75-7.25L341,382l-.71-3,3.49-3.89,4.59-5.11,8.61-9.82.05-.06,11.49-12.49.08-.08,7.36-3,1.42-.58.23,0c.88-.15,4.26-.46,8.79,2.1a25.2,25.2,0,0,0,10.27,3.18A32.12,32.12,0,0,1,416,357.53L453,377l58.25,21s5-28.75,13.5-22.5S528.5,405.53,528.5,405.53Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#cc818c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M389.8,384.85c-2.84,3.55-6,7.3-6.8,7.43-1.5.25-24.75,3.5-24.75,3.5l-15.75-7.25L341,382l-.71,1.75-7.5,8L328,402l-11.2,6.5-12.05-6.25-5.5-8,1.25-11.46c.63-1.36,2.35-5.06,3.92-8.18a25,25,0,0,1,2.78-4.86c1-.66,2.05-7.75,2.05-7.75C313.79,348.91,329,346.9,329,346.9l2.43,2.28,1.06,1.1c-.43-.07.08-1-.47-.85-.88.25-1.27,1.58-2.4,2.31-6.15,4-15.76,13.33-19.56,17.76-.92,1.07-1.87,2.12-2.84,3.14-5.49,5.81-4.48,13.51-4.48,13.51-1.37,6,10.75,10.5,10.75,10.5,3.38-5.62,26.25-21.12,26.25-21.12l15.4-17.25c4.72-8.22,14-13.65,19.18-16.19,2.29-1.12,3.79-1.68,3.79-1.68l5.76,2.46a7.68,7.68,0,0,0-4.61.2,15.75,15.75,0,0,0-2.47,1c-.3.15-.6.31-.88.48a27.55,27.55,0,0,0-4.42,3.19l-12.94,14.13c-9.89,10.79-2.44,28.24,12.19,28.49h.13C379.81,392.42,386.22,388.28,389.8,384.85Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M364.62,702.15s-1.85,5.72-4.4,13.45c-9.78.73-25.93-3.05-32.16-4.65l1.32-6.67Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M332.5,350.28,329.3,347s-11.55,1.58-18.72,13.92c0,0-3.35,9.25-4.38,9.91s-6.95,13.59-6.95,13.59-7.08,20.91-1.17,33.75,6.17,18.75,6.17,18.75l4.42,19,1.83,16.66,15.88,39.25L341,532.66s-1.37,15.37-4.37,17.5S335,563.28,335,563.28l-1.87,28.88s-5.88,8.62-6.25,22.62-2.5,18-2.5,18-1,11.75,1.75,17.13-4.38,11-4.38,11l6.13,20.87-2.38,26.5s28.25,7.88,38.75,4.63,16-1,16-1L399,636l6.5-59.62s.38-42.25,6-55.13c4.82-11-1.5-50.19-23.21-57.59-4.53-1.54-6.83-6.68-10.7-9.5-3.46-2.51-9.11-8.44-6.34-19.16,3.88-15,13.63-38.62,13.63-38.62L392.1,382s-7.85,12.7-22.22,9.45h-.13c-14.63-.26-22.08-17.71-12.19-28.49l12.94-14.14s7.13-6.57,12.38-4.91l-5.75-2.46s-16.19,6-23,17.87l-15.4,17.25S315.88,392,312.5,397.66c0,0-12.12-4.5-10.75-10.5,0,0-1-7.71,4.48-13.52,1-1,1.92-2.06,2.84-3.13C314,364.75,327.63,349.47,332.5,350.28Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#565987"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M334.38,453.28s-3.63,26.38-.88,31.75Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336.75,463.53l3.88,15.13S342,469.41,336.75,463.53Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.75,460s7.75,38.5,16.25,50.13",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M368.38,506.41S355.13,518.91,350,518c0,0,20.38.88,26.75-9.87C376.75,508.16,372.63,505.16,368.38,506.41Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M386.75,505.41s-17,12.37-20.37,13.5C366.38,518.91,384.75,513.66,386.75,505.41Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M329.25,413.53s-8.5,10.88-12.75,9.63C316.5,423.16,326.88,423.53,329.25,413.53Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M338.88,427.53s18.5-25.12,27.25-24.12C366.13,403.41,345.13,421.66,338.88,427.53Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M364.5,418.39S352.75,424.28,354,426,364.5,418.39,364.5,418.39Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M373,611.28s-39.25,22.88-42.87,24c0,0,6.75,5.13,13.12,2.63S373,611.28,373,611.28Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M340.13,658.91s-15.75-1.63-15.13,3.5S340.13,658.91,340.13,658.91Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M359.75,303s-.32,6.4-.32,16.38h0a30.28,30.28,0,0,1-26.91,5.86,116,116,0,0,0-5.77-17.5Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253.93,
    cy: 243.48,
    r: 30.25,
    fill: "#cc818c"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M348.18,312.5c.85,12.37,3.45,26.52,14.19,32.74,7.76,4.49,17.54,3.31,26.13.75s17-6.38,25.94-6.81c6.87-.33,13.66,1.36,20.51,1.79s14.35-.64,19.24-5.46c7-6.86,5.72-19.33-.91-26.54s-17-9.83-26.82-9.56c-12,.33-25.4,4-34.89-3.28-6.37-4.9-8.78-13.4-14.14-19.39-8.95-10-48.53-24.44-56.91-8.14-3.93,7.63,13.93,13.08,18.07,18.6C345.13,295.91,347.4,301.08,348.18,312.5Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M349.11,311.43c.86,12.38,3.45,26.53,14.19,32.74,7.76,4.49,17.54,3.31,26.13.76s17-6.38,25.95-6.81c6.86-.33,13.65,1.35,20.51,1.79s14.34-.64,19.23-5.46c7-6.87,5.72-19.33-.91-26.54s-17-9.83-26.81-9.56c-12,.32-25.41,4-34.9-3.29-6.37-4.9-8.78-13.39-14.14-19.39-8.95-10-48.53-24.43-56.91-8.13-3.93,7.62,13.93,13.07,18.08,18.6C346.06,294.84,348.33,300,349.11,311.43Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#663d5b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M312.73,396.64a27.94,27.94,0,0,1,11.89-19.74",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M426.15,553.28a9.85,9.85,0,0,1-.71,2.85,90.93,90.93,0,0,1-4.72,11.47c2.67-.23,4.87-2.33,6-4.75a23,23,0,0,0,1.61-7.81,14.16,14.16,0,0,0,.07-2.52c-.07-.78-.57-3.76-1.86-3.23C425.5,549.73,426.17,552.49,426.15,553.28Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M456.92,331.32c-4.9,4.82-12.38,5.9-19.24,5.46S424,334.66,417.17,335c-9,.43-17.34,4.25-25.94,6.81s-18.37,3.74-26.14-.75c-10.73-6.22-13.33-20.37-14.18-32.74-.78-11.42-3.06-16.59-9.59-25.3-3.95-5.27-20.35-10.47-18.47-17.55a11.14,11.14,0,0,0-1.4,2.08c-3.93,7.62,13.93,13.07,18.08,18.6,6.53,8.7,8.8,13.88,9.58,25.29.86,12.38,3.45,26.53,14.19,32.74,7.76,4.49,17.54,3.31,26.13.76s17-6.38,25.95-6.81c6.86-.33,13.65,1.35,20.51,1.79s14.34-.64,19.23-5.46a14.92,14.92,0,0,0,3.25-4.82A14.4,14.4,0,0,1,456.92,331.32Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "224.24 371.69 220.57 379.69 232.24 377.36 224.24 371.69",
    fill: "#cc818c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.24 371.69 221.22 379.69 220.57 379.69 224.24 371.69",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 513.02,
    cy: 729.17,
    rx: 41,
    ry: 5.63,
    fill: "#eb5200",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 670.07,
    cy: 745.09,
    rx: 41,
    ry: 5.63,
    fill: "#eb5200",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 855.06,
    cy: 723.54,
    rx: 41,
    ry: 5.63,
    fill: "#eb5200",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.21,
    cy: 790.43,
    rx: 29.14,
    ry: 4,
    fill: "#eb5200",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.21,
    cy: 786.43,
    rx: 29.14,
    ry: 4,
    fill: "#eb5200",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M757.28,794.39s-57.5-188.5,9-264c49.74-56.48,106.21-49.72,131.5-42.74a46.71,46.71,0,0,1,30.16,25.07c8.84,19.08,7.25,50-55.16,86.17-104.5,60.5-111,143.5-111,143.5Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M888.78,514.39s-169.5,53-131.5,280",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M789.78,533.39s23.33,15.73,15.92,39.36",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M871.78,547.39s-14.27-14.52-31.64-6.51",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M804.78,620.39s-25.06-12.72-31.54,3.21",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M742.78,646.89s18.81-1.5,19.15,7.5",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M755,795.89s67.34-137,85.84-134c8.79,1.42,12.84,10.07,14.67,18.75A55.1,55.1,0,0,1,851.79,714C842.24,735.91,816.57,777.54,755,795.89Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M840.29,687.89s-70.68,102.5-84.34,107",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 760.47,
    y1: 653.33,
    x2: 743.97,
    y2: 653.33,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 740.71,
    y1: 690.83,
    x2: 714.85,
    y2: 691.94,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 724.97,
    y1: 660.83,
    x2: 727.78,
    y2: 674.3,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 697.47,
    y1: 701.83,
    x2: 697.97,
    y2: 714.07,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M757,795.89s-67.34-137-85.84-134c-8.79,1.42-12.84,10.07-14.67,18.75A55.1,55.1,0,0,0,660.11,714C669.66,735.91,695.33,777.54,757,795.89Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M671.61,687.89s70.68,102.5,84.34,107",
    transform: "translate(-86.32 -50.56)",
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 578.78,
    y1: 653.33,
    x2: 595.28,
    y2: 653.33,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 598.55,
    y1: 690.83,
    x2: 624.41,
    y2: 691.94,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 614.28,
    y1: 660.83,
    x2: 611.48,
    y2: 674.3,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 641.78,
    y1: 701.83,
    x2: 641.28,
    y2: 714.07,
    fill: "none",
    stroke: "#565987",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M872.58,827.88a11.63,11.63,0,0,0,3.84-5.78c.49-2.3-.49-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.48s-4.28,3.69-6.89,3.32A10.47,10.47,0,0,0,863,812.2a4,4,0,0,0-.9-2c-1.36-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.67,17.08-.53-2.3-.09-4.69-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-1c-2.34-.08-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.76,5.42a14.82,14.82,0,0,1,4.84,4.61,4.41,4.41,0,0,1,.36.82h14.65A40.77,40.77,0,0,0,872.58,827.88Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M616,772.71a11.64,11.64,0,0,0,3.83-5.79c.5-2.3-.48-5-2.68-5.89-2.46-.94-5.08.76-7.08,2.49s-4.28,3.68-6.88,3.32A10.5,10.5,0,0,0,606.4,757a4.08,4.08,0,0,0-.9-2c-1.37-1.46-3.84-.84-5.48.31-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.65-6.23a7.91,7.91,0,0,0-4-.94c-2.33-.09-4.94.14-6.53,1.85-2,2.13-1.47,5.69.25,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.83,4.61,4.16,4.16,0,0,1,.36.83h14.66A41.11,41.11,0,0,0,616,772.71Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M701.49,827.88a11.63,11.63,0,0,0,3.84-5.78c.49-2.3-.49-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.48s-4.28,3.69-6.89,3.32a10.47,10.47,0,0,0,3.24-9.81,4,4,0,0,0-.9-2c-1.36-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.67,17.08-.53-2.3-.09-4.69-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-1c-2.34-.08-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.76,5.42a14.82,14.82,0,0,1,4.84,4.61,4.41,4.41,0,0,1,.36.82h14.65A40.77,40.77,0,0,0,701.49,827.88Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M944,716.35s5.5,7.18-2.53,18-14.65,20-12,26.76c0,0,12.12-20.14,22-20.42S954.89,728.46,944,716.35Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M944,716.35a8.63,8.63,0,0,1,1.12,2.25c9.63,11.3,14.75,21.85,5.5,22.12-8.61.24-18.94,15.65-21.42,19.54a9.06,9.06,0,0,0,.29.88s12.12-20.14,22-20.42S954.89,728.46,944,716.35Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M954.25,725.5c0,2.53-.28,4.58-.63,4.58S953,728,953,725.5s.35-1.33.7-1.33S954.25,723,954.25,725.5Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#ffd037"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M957.76,728.52c-2.22,1.21-4.16,1.94-4.32,1.64s1.49-1.54,3.71-2.75,1.35-.33,1.51,0S960,727.31,957.76,728.52Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#ffd037"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M915,716.35s-5.5,7.18,2.53,18,14.65,20,12,26.76c0,0-12.11-20.14-22-20.42S904.18,728.46,915,716.35Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#eb5200"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M915,716.35a8.82,8.82,0,0,0-1.13,2.25c-9.62,11.3-14.74,21.85-5.5,22.12,8.62.24,19,15.65,21.43,19.54a7,7,0,0,1-.3.88s-12.11-20.14-22-20.42S904.18,728.46,915,716.35Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M904.81,725.5c0,2.53.29,4.58.64,4.58s.63-2.05.63-4.58-.35-1.33-.7-1.33S904.81,723,904.81,725.5Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#ffd037"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M901.31,728.52c2.22,1.21,4.15,1.94,4.32,1.64s-1.49-1.54-3.71-2.75-1.35-.33-1.52,0S899.09,727.31,901.31,728.52Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#ffd037"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M906.56,760.2s15.36-.47,20-3.77,23.63-7.23,24.78-1.94,23.08,26.29,5.74,26.43-40.29-2.7-44.91-5.52S906.56,760.2,906.56,760.2Z",
    transform: "translate(-86.32 -50.56)",
    fill: "#a8a8a8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M957.38,779.08c-17.34.14-40.3-2.7-44.92-5.52-3.51-2.14-4.92-9.83-5.38-13.38l-.52,0s1,12.39,5.6,15.2,27.57,5.66,44.91,5.52c5,0,6.73-1.82,6.64-4.46C963,778.05,961.1,779.05,957.38,779.08Z",
    transform: "translate(-86.32 -50.56)",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.29fc4387291b0f2bd89db8d8b8f91341.svg";
export { ForwardRef as ReactComponent };